import { hover } from 'pobble-components/dist/jss-mixins'

export default ({ ICONS_SIZES }) => ({
  container: {
    width: '40px',
    height: '40px',
    borderRadius: '100%',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    ...hover({
      opacity: '0.8'
    })
  },
  icon: {
    width: ICONS_SIZES.MEDIUM,
    height: ICONS_SIZES.MEDIUM
  }
})
